import { render, staticRenderFns } from "./RegenerateThumbs.vue?vue&type=template&id=ffab5cd8"
import script from "./RegenerateThumbs.vue?vue&type=script&lang=ts"
export * from "./RegenerateThumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports